import { Expose } from 'class-transformer';

import { Component, Input, OnInit } from '@angular/core';

import { ExposeFunction } from '@lib/common/decorators';
import { BASE_COLORS } from '@lib/ui/theme';

import { speedDialFabAnimations } from './speed-dial-fab.animations';

export type FsFabButtonDisableExpression = () => boolean;

export class FsFabButton {
  @Expose()
  public fontSet: string;

  @Expose()
  public fontIcon: string;

  @Expose()
  public label: string;

  @Expose()
  public icon?: string;

  @ExposeFunction()
  public click?: () => void;

  @ExposeFunction()
  public disabled?: boolean | FsFabButtonDisableExpression;
}

export enum FsFabButtonState {
  Inactive = 'inactive',
  Active = 'active',
}

@Component({
  selector: 'sn-speed-dial-button',
  templateUrl: './speed-dial-button.component.html',
  styleUrls: ['./speed-dial-button.component.scss'],
  inputs: ['disabled', 'color'],
  animations: speedDialFabAnimations,
})
export class SpeedDialButtonComponent implements OnInit {
  @Input() public fabButtons: FsFabButton[] = [];
  @Input() public fabTogglerState = 'inactive';
  @Input() public iconColor: string = BASE_COLORS['accent-400'];
  public buttons = [];

  constructor() {}

  public ngOnInit(): void {}

  public showItems(): void {
    this.fabTogglerState = FsFabButtonState.Active;
    this.buttons = this.fabButtons;
  }

  public hideItems(): void {
    this.fabTogglerState = FsFabButtonState.Inactive;
    this.buttons = [];
  }

  public onToggleFab(): void {
    this.buttons.length ? this.hideItems() : this.showItems();
  }
}
